import { makeStyles, Theme } from '@material-ui/core/styles';

const styles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
  },
  tabs: {
    fontSize: 12,
    height: 30,
    boxShadow: '0 0px 0px 0px rgba(255, 105, 135, .3)',
  },
  divItems: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  formControl: {
    marginRight: 0,
    marginLeft: 0,
    marginTop: 10,
    marginBottom: 10,
    minWidth: 120,
  },
  appBar: {
    backgroundColor: theme.palette.white.main,
    position: 'absolute',
  },
  dialogTitle: {
    backgroundColor: theme.palette.white.main,
    height: 30,
    marginTop: 0,
    padding: 16,
    paddingTop: 0,
  },
  dialogContent: {
    background: 'linear-gradient(to bottom, white 97.5px, #e3e5e6 0%)',
    minHeight: '80vh',
    overflow: 'none',
  },
  dialogActions: {
    backgroundColor: theme.palette.constrastGreyNormal.main,
  },
  tabSelected: {
    backgroundColor: theme.palette.constrastGreyNormal.main,
    color: theme.palette.primary.main,
  },
  tabNotSelected: {
    backgroundColor: theme.palette.white.main,
    color: theme.palette.secondary.main,
  },
  chip: {
    backgroundColor: theme.palette.white.main,
  },
  tabPanel: {
    backgroundColor: theme.palette.constrastGreyNormal.main,
  },
  tabBackground: {
    backgroundColor: theme.palette.constrastGreyNormal.main,
    position: 'relative',
    minHeight: 700,
    width: '100%',
  },
}));

export const useChipStyles = makeStyles({
  root: {
    border: '1px solid #C4C4C4',
    borderRadius: '4px',
    '& fieldset': {
      border: 0,
    },
  },
  chipInput: {
    margin: '0 8px 8px 0',
  },
  inputRoot: {
    maxHeight: '220px',
    overflowY: 'scroll',
    margin: '0 8px 8px 0',
  },
});

export default styles;
